export default "__VITE_ASSET__wf5dMnHy__"